module.exports = __webpack_public_path__ + "media/images/xpass/markers/inactive-selected/yogasix-159a89d7ec9919a40b236809fdd78d14.png";